// extracted by mini-css-extract-plugin
export default {"select":"xy28u"};